import * as React from 'react';
import styles from './LoadMoreFooter.module.scss';

export function LoadMoreFooter(props: { showing?: number; }) {
    const message = `Showing top ${props.showing ? props.showing : 'some'} items, search to refine your results.`;

    return (
        <div className={styles.loadMoreBar}>
            <span className={styles.message}>{message}</span>
        </div>
    );
}
